import axios from "axios";

// (iter 40) Risolve runtime il baseURL del backend.
// Nel browser usa SEMPRE same-origin (window.location.origin): zero cross-site,
// zero problemi ITP Safari iOS, cookie HttpOnly first-party. Funziona identico
// su apex (striano-ncc.it), www, preview emergent (driver-fleet-manager-6.preview...)
// e qualunque futuro mirror. Fallback a REACT_APP_BACKEND_URL solo quando `window`
// non è disponibile (SSR / build tool).
function resolveBackendOrigin() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    const o = window.location.origin;
    if (o && !o.startsWith("file:")) return o;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

const BACKEND_URL = resolveBackendOrigin();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Silently swallow 403 rejections so role-restricted endpoints don't surface
// as global unhandled-rejection overlays. Consumers still receive the rejection.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403) {
      // eslint-disable-next-line no-console
      console.debug("[api] 403 on", err.config?.url);
    }
    return Promise.reject(err);
  }
);

// Prevent unhandled 403 rejections from triggering global error overlays
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e?.reason?.response?.status === 403) {
      e.preventDefault();
    }
  });
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Errore di rete";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function fmtEUR(n) {
  const v = Number(n || 0);
  return v.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}
export function fmtNum(n) {
  return Number(n || 0).toLocaleString("it-IT");
}
export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
}
